import { useEffect } from 'react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { RULES_PAGE_TABS } from '@/data/constants'
import { getLastRoutePath } from '@/utils/route-utils'
import MobileTabMenu from './mobile-tab-menu'
import { Dialog, DialogTrigger } from '@/components/ui/dialog'
import CreateRules from './rules/create-rules'
import CreateCategories from './category/create-categories'
import CreateGroup from './group/create-group'
import CreateGrants from './grants/create-grants'

const RulesPage = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const selectedTab = getLastRoutePath(pathname)

  useEffect(() => {
    if (selectedTab === 'home') navigate('grants')
  }, [selectedTab, navigate])

  return (
    <div className="md:px-[10%] md:pt-[2%] bg-bgGray min-h-screen h-auto p-5" data-testid="rules-page-container">
      <div className="flex flex-col md:gap-8 gap-5">
        <div className="flex justify-between items-center">
          <p className="text-2xl md:text-3xl/[38px] font-semibold text-[--gray-900]">Rewards</p>
          <div>
            <Dialog>
              <DialogTrigger>
                {selectedTab === 'all-rules' && <CreateRules />}
                {selectedTab === 'categories' && <CreateCategories />}
                {selectedTab === 'group' && <CreateGroup />}
                {selectedTab === 'grants' && <CreateGrants />}
              </DialogTrigger>
            </Dialog>
          </div>
        </div>
        {/* Defines Rules tab*/}
        <div className="md:gap-2 md:border-b md:block relative">
          <div className="flex flex-row gap-3">
            <div className="md:flex hidden gap-3">
              {Object.entries(RULES_PAGE_TABS).map(([key, tab]) => (
                <Link key={key} to={key}>
                  <div
                    className={cn(
                      selectedTab === key ? 'border-solid border-b-2 border-[--brand-600]' : null,
                      'px-1 pb-3'
                    )}
                  >
                    <div
                      className={`text-sm font-semibold px-0 ${
                        selectedTab === key ? 'text-brand-700' : 'text-dGray-500'
                      }`}
                    >
                      {tab.title}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="md:hidden pt-6 w-[327px]">
          <MobileTabMenu />
        </div>
        {/* Render the child routes */}
        <Outlet />
      </div>
    </div>
  )
}

export default RulesPage
